import React, { useEffect, useRef, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import provenResult from "../../assets/image/Asset 1 (1).png";
import chatImg from "../../assets/image/Asset-17.png";
import downImg from "../../assets/image/Layer_1.png";
import banner from "../../assets/image/bannerbg.jpg";
import Footer from "./Footer";
import WhatClientSayCarousel from "./Components/UI/WhatClientSayCarousel ";
import { NewNavbar } from "./Pages/NewNavbar";
import FormInput from "./Components/UI/FormInput";
import SwitchTab from "./Components/UI/SwtichTabs";
import ProductListing from "./Components/ProductListing";
import CenterMode from "./Components/UI/CenterMode";
import { ListRendering } from "./Components/UI/ListRendering";
import PropertyPage from "./Components/UI/list/PropertyPage";
import { propertyListing } from "../../api/idx";
import { useDispatch, useSelector } from "react-redux";
import {
  changeSorting,
  changeSpecialFeature,
  changeToAny,
  onToggleFilter,
  resetPageNo,
  setSearchedContent,
  setSearchedResult,
} from "../../state/filterActions";
import { useHistory } from "react-router-dom";

const LUXURY_MIN_PRICE = 1000000;
const FEATURED_MIN_PRICE = 500000;

export default function HomePage() {
  const dispatch = useDispatch();
  const history = useHistory();
  // const [buySellActive, setbuySellActive] = useState(true);
  const [dataListing, setDataListing] = useState<any>([]);

  const [loading, setLoading] = useState<boolean>(true);

  const modalFilter = useSelector(
    (store: any) => store?.filterReducer?.modalFilter
  );
  const propertytype = useSelector(
    (store: any) => store?.filterReducer?.propertytype
  );

  const propertysubtype = useSelector(
    (store: any) => store?.filterReducer?.propertysubtype
  );
  const specialFeature = useSelector(
    (store: any) => store?.filterReducer?.specialFeature
  );
  const sorting = useSelector((store: any) => store?.filterReducer?.sorting);
  const locationParams = useSelector(
    (store: any) => store?.filterReducer?.locationParams
  );
  const pageNo = useSelector((store: any) => store?.filterReducer?.pageNo);
  const pageSize = useSelector((store: any) => store?.filterReducer?.pageSize);
  const toggleFilter = useSelector(
    (store: any) => store?.filterReducer?.toggleFilter
  );

  const clearFilter = useSelector(
    (store: any) => store?.filterReducer?.clearFilter
  );
  const isSortType = useSelector(
    (store: any) => store?.filterReducer?.isSortType
  );

  const [dataByTab, setDataByTab] = useState({}); // Store listings per tab
  const timeoutRef = useRef(null);
  let abortController = null;
  useEffect(() => {
    (async function () {
      setLoading(true);
      let listing: any = await propertyListing({
        ...modalFilter,
        propertytype,
        propertysubtype,
        ...specialFeature,
        ...sorting,
        ...locationParams,
        pageNo,
        pageSize,
        pricemin: FEATURED_MIN_PRICE,
      });

      setDataListing(listing?.value);
      setLoading(false);
    })();
  }, [
    clearFilter,
    toggleFilter,
    modalFilter,
    propertytype,
    propertysubtype,
    specialFeature,
    sorting,
    locationParams,
    pageNo,
    pageSize,
  ]);
  const buySellActive = true;

  const tabs = [
    {
      title: "BUY",

      content: (
        <div className="searchSection">
          <button className="searchBtnBuySell">
            <i className="fa-solid fa-magnifying-glass"></i>
          </button>
          <FormInput
            name={"sell"}
            className={"mb-0"}
            type={"search"}
            InputclassName={"buy-sell-search mb-0"}
            placeholder={"Search properties by city, zip, neighborhood"}
            value={undefined}
            onChange={undefined}
            error={undefined}
          />
        </div>
      ),
    },
    {
      title: "SELL",

      content: (
        <div className="searchSection">
          <button className="searchBtnBuySell">
            <i className="fa-solid fa-magnifying-glass"></i>
          </button>
          <FormInput
            name={"sell"}
            className={"mb-0"}
            type={"search"}
            InputclassName={"buy-sell-search mb-0"}
            placeholder={"Search properties by city, zip, neighborhood "}
            value={undefined}
            onChange={undefined}
            error={undefined}
          />
        </div>
      ),
    },
  ];
  const tabContent = (
    <ListRendering dataListing={dataListing} loading={loading} />
  );
  const homeTabs = [
    {
      title: "Featured",
      tabtype: "featured",
      content: tabContent,
    },
    {
      title: "New To Market",
      tabtype: "new_listing",
      content: tabContent,
    },
    {
      title: "Price Improvements",
      tabtype: "highest_price",
      content: tabContent,
    },
    {
      title: "Open Houses",
      tabtype: "open_house_date",
      content: tabContent,
    },
    {
      title: "Luxury",
      tabtype: "luxury",
      content: tabContent,
    },
  ];
  const [activeTab, setActiveTab] = useState("featured");
  const timeoutId = useRef(null);
  const handleClicktab = (tabId) => {
    setActiveTab(tabId);
    // Clear any existing delayed dispatch to avoid multiple triggers

    if (timeoutId.current) clearTimeout(timeoutId.current);
    timeoutId.current = setTimeout(() => {
      if (tabId === "luxury") {
        dispatch(resetPageNo());
        dispatch(changeToAny());

        dispatch(
          changeSpecialFeature({
            luxury: specialFeature?.luxury ? null : true,
          })
        );

        console.log("luxury items ", tabId, dataListing);
      } else if (tabId === "new_listing") {
        dispatch(
          changeSorting({
            sortKey: "new_listing",
            sortValue: true,
          })
        );
        dispatch(onToggleFilter());
        console.log("new_listing items ", tabId, dataListing);
      } else if (tabId === "open_house_date") {
        dispatch(resetPageNo());
        dispatch(changeToAny());
        dispatch(
          changeSorting({
            sortKey: "open_house_date",
            sortValue: true,
          })
        );
        dispatch(onToggleFilter());
      } else if (tabId === "highest_price") {
        dispatch(resetPageNo());
        dispatch(changeToAny());
        dispatch(
          changeSorting({
            sortKey: "highest_price",
            sortValue: true,
          })
        );
        dispatch(onToggleFilter());
      } else {
        dispatch(changeSorting({ sortKey: tabId, sortValue: true }));
      }
    }, 1000);
  };

  return (
    <>
      <NewNavbar buySellActive={buySellActive} />
      {/* New home banner page section start */}
      <div className="banner-bg-img ">
        <div className="main-banner-content row">
          <h1 className="main-banner-content-heading text-center">
            Milford: Where Home Begins
            {/* <h4
              style={{
                fontSize: "1.7rem",
                fontWeight: "normal",
                fontFamily: "serif",
              }}
            >
              At Milford Real Estate, we believe in transforming the way real
              estate transactions are conducted. We pride ourselves on our
              ability to disrupt industry norms by focusing on what truly
              matters
            </h4> */}
          </h1>

          {/* <div className="buy-sell-tab">
            <SwitchTab
              tabs={tabs}
              defaultActiveIndex={0}
              tabContentClass={"buy-sell-tab-content"}
              navItemClass={"col-md-6 p-0"}
              navClass={undefined}
              containerClass={null}
              ontabClick={handleClicktab}
            />
          </div> */}
        </div>
      </div>
      {/* New home banner page section end */}

      {/* down image section start */}
      <div className="my-5">
        <div className="d-flex justify-content-center">
          <img src={downImg} alt="down image" />
        </div>
      </div>
      {/* down image section end */}

      {/* Explore Home section start with Carousel */}
      <div className="text-center">
        <h1 className="main-banner-content-heading fw-light">Explore Home</h1>
        {/* Explore Tab section start */}
        <div className="explore-home-section">
          <SwitchTab
            ontabClick={handleClicktab}
            tabs={homeTabs}
            navClass={"mb-3 justify-content-center"}
          />
        </div>
        {/* Explore Tab section start */}
      </div>
      {/* Explore Home section end with Carousel */}

      {/* Proven Result section start */}
      <div className="container  provenResult d-flex align-items-center my-5">
        <div className=" d-flex align-items-center proven-text-wrap">
          <div>
            <p className="proven-text">Proven</p>
            <p className="result-text">Results</p>
          </div>

          <img src={provenResult} alt="" className="proven-middle-img" />
          <p className="proven-main-text">
            At Milford Real Estate, we believe in transforming the way real
            estate transactions are conducted. We pride ourselves on our ability
            to disrupt industry norms by focusing on what truly matters:{" "}
            <span className="you-text"> you.</span>
          </p>
        </div>
      </div>

      <Footer />
    </>
  );
}
